var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex flex-column py-10 justify-around lg:hidden sm:hidden md:hidden"},[_c('more-left'),_c('div',{staticClass:"mx-4"},[_c('more-right')],1)],1),_c('div',{staticClass:"flex flex-row hidden py-10 justify-around lg:flex md:block"},[_c('more-left'),_c('more-right')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }